export default "__VITE_ASSET__rTPgbRku__"